import { auth, firestore } from './../../firebase/utils';



export const handleResetPasswordAPI = (email) => {
	const config = {
	  url: 'http://localhost:3000/'
	};
  
	return new Promise((resolve, reject) => {
	  auth.sendPasswordResetEmail(email, config)
		.then(() => {
		  resolve();
		})
		.catch(() => {
		  const err = ['Email not found. Please try again.'];
		  reject(err);
		});
	});
  };

  export const handleUpdateUser = (id, user) => {
	return new Promise((resolve, reject) => {
	  firestore
		.collection('users')
		.doc(id)
		.update(user)
		.then(() => {
		  resolve();
		})
		.catch(err => {
		  reject(err);
		})
	});
  }

export const handleFetchCustomers = () => {
	return new Promise((resolve, reject) => {
  
	  let ref = firestore
	  				.collection('users')
					.where("userRoles", "array-contains", "customer")
					
	  ref
		.get()
		.then(snapshot => {
		
  
		  const customersData = [
	
			...snapshot.docs.map(doc => {
			  return {
				...doc.data(),
              	documentID: doc.id
			  }
			})
		  ];
  
		  resolve({
			customersData
		  });
		})
		.catch(err => {
		  reject(err);
		})
	})
}

export const handleFetchVendors = () => {
	return new Promise((resolve, reject) => {
  
	  let ref = firestore
	  				.collection('users')
					.where("userRoles", "array-contains", "vendor")
					
	  ref
		.get()
		.then(snapshot => {
		
  
		  const vendorsInfoData = [
	
			...snapshot.docs.map(doc => {
			  return {
				...doc.data(),
              	documentID: doc.id
			  }
			})
		  ];
  
		  resolve({
			vendorsInfoData
		  });
		})
		.catch(err => {
		  reject(err);
		})
	})
}
